module.exports = __webpack_public_path__ + "static/img/map_cas.9f32fa4.svg";